// ========================================
// MSAL CONFIGURATION FOR AZURE AD
// ========================================

// Use environment variable in production, otherwise use current origin (adapts to any port)
const baseUrl = process.env.REACT_APP_BASE_URL || window.location.origin;
const tenantId = process.env.REACT_APP_AZURE_TENANT_ID || 'common';

export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
        // Single-tenant: use specific tenant ID
        authority: `https://login.microsoftonline.com/${tenantId}`,
        redirectUri: `${baseUrl}/auth/redirect`,
        postLogoutRedirectUri: `${baseUrl}/auth/redirect`,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    }
};

export const loginRequest = {
    scopes: ['https://graph.microsoft.com/User.Read']
};
